import { userModel } from 'entities/user';
import { ContractsService, NATIVE_CURRENCY_ADDRESS } from 'shared';
import { error, request, success } from 'shared/api';
import { call, put, select, takeLatest } from 'typed-redux-saga';

import { userActions } from '../reducer';

export function* getTokenBalanceSaga({
  type,
  payload: { web3Provider, tokenAddress, isNativeCurrency = false },
}: ReturnType<typeof userActions.getTokenBalance>) {
  try {
    yield put(request(type));
    const { address: userWalletAddress } = yield select(userModel.selectors.selectUserWeb3Info);

    if (userWalletAddress) {
      if (isNativeCurrency) {
        const balance = yield* call(web3Provider.eth.getBalance, userWalletAddress, web3Provider.eth.defaultBlock);
        yield put(userActions.updateUserTokens({ [NATIVE_CURRENCY_ADDRESS]: { balance, decimals: '18', symbol: '' } }));
      } else {
        const contractsService = new ContractsService(web3Provider);
        const tokenContract = contractsService.getErc20Contract(tokenAddress);
        const balance = yield* call(tokenContract.methods.balanceOf(userWalletAddress).call);
        const decimals = yield* call(tokenContract.methods.decimals().call);
        const symbol = yield* call(tokenContract.methods.symbol().call);
        yield put(
          userActions.updateUserTokens({
            [tokenAddress]: { balance, decimals, symbol } as { balance: string; decimals: string; symbol: string },
          }),
        );
      }
    }

    yield put(success(type));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    yield put(error(type));
  }
}

export default function* listener() {
  yield takeLatest(userActions.getTokenBalance.type, getTokenBalanceSaga);
}
